import * as z from 'zod';

export const VERIFY_BUSINESS_FORM_SCHEMA = z.object({
  fullName: z.string().min(1, 'Full name is required.'),
  phoneNumber: z
    .string()
    .regex(/^\+?[1-9]\d{1,14}$/, 'Must be a valid number.'),
  email: z.string().email('Must be a valid email.')
});
